import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useOrganizationsService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';
import { QUERY_KEYS } from '@restworld/utils-common';
import { Organization } from '@restworld/utility-types';

export function useShowOrganisationQuery({ context, staleTime }: { context: string; staleTime?: number }) {
  const organisationsService = useOrganizationsService();
  const { user } = useAuth();
  const queryKey = useShowOrganisationQueryKey();

  const query = useQuery({
    queryKey,
    queryFn: async () => (await organisationsService.showOrganization(user?.organization_id, context)).data,
    staleTime,
    enabled: !!user?.organization_id,
  });
  return { organisationDetails: query.data, query };
}

export const useShowOrganisationQueryKey = () => [QUERY_KEYS.ORGANISATIONS.DETAILS];

export const useShowOrganizationData = () => {
  const queryKey = useShowOrganisationQueryKey();
  return useQueryClient().getQueryData(queryKey) as Organization;
};

export const useIsShowOrganisationQueryLoading = () => {
  const queryKey = useShowOrganisationQueryKey();
  return useQueryClient().getQueryState(queryKey).status === 'pending';
};

export default useShowOrganisationQuery;
